/* home-kit.js — behavior for the hk-* homepage sections.
   Sections each print their own script tag; the guard keeps one instance. */
(function () {
  'use strict';
  if (window.__homeKit) return;
  window.__homeKit = true;

  function init(root) {
    /* ---- rails: arrow scrolling + edge state ---- */
    root.querySelectorAll('[data-hk-rail]').forEach(function (rail) {
      var prev = rail.querySelector('[data-hk-prev]');
      var next = rail.querySelector('[data-hk-next]');
      if (!prev || !next) return;
      function activeTrack() {
        var tracks = rail.querySelectorAll('.hk-rail__track');
        for (var i = 0; i < tracks.length; i++) {
          var panel = tracks[i].closest('.hk-rail__panel');
          if (!panel || (!panel.hidden && !panel.classList.contains('is-leaving'))) return tracks[i];
        }
        return tracks[0];
      }
      function step(dir) {
        var track = activeTrack();
        if (track) track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      }
      function sync() {
        var track = activeTrack();
        if (!track) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.querySelectorAll('.hk-rail__track').forEach(function (t) {
        t.addEventListener('scroll', sync, { passive: true });
      });
      rail.addEventListener('hk:tabchange', sync);
      sync();
    });

    /* ---- BETWEEN*LAPS heading: arm closed, play once on scroll-in ---- */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      root.querySelectorAll('[data-hk-laps]').forEach(function (h) {
        h.classList.add('hk-laps--armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { h.classList.add('is-on'); io.disconnect(); }
          });
        }, { threshold: 0.6 });
        io.observe(h);
      });
    }

    /* ---- product rail tabs ---- */
    root.querySelectorAll('[data-hk-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.hk-tab');
      /* edge fades on a scrolling tab row: only the side that hides tabs */
      if (wrap.classList.contains('hk-tabs--display')) {
        var fade = function () {
          var max = wrap.scrollWidth - wrap.clientWidth;
          var x = wrap.scrollLeft;
          wrap.style.setProperty('--hk-fade-l', max > 1 && x > 1 ? '4.8rem' : '0px');
          wrap.style.setProperty('--hk-fade-r', max > 1 && x < max - 1 ? '8rem' : '0px');
        };
        fade();
        wrap.addEventListener('scroll', fade, { passive: true });
        window.addEventListener('resize', fade);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fade);
      }
      var panelOf = function (t) { return document.getElementById(t.getAttribute('aria-controls')); };
      /* hidden panels keep their images lazy; intent (hover, focus, touch)
         starts the download so the photos are there by the click */
      var warm = function (t) {
        var p = panelOf(t);
        if (!p || p.dataset.hkWarm) return;
        p.dataset.hkWarm = '1';
        p.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      };
      tabs.forEach(function (tab) {
        ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
          tab.addEventListener(ev, function () { warm(tab); }, { passive: true });
        });
        tab.addEventListener('click', function () {
          if (tab.getAttribute('aria-selected') === 'true') return;
          warm(tab);
          var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var next = panelOf(tab);
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          var panels = [];
          tabs.forEach(function (t) { var p = panelOf(t); if (p) panels.push(p); });
          var rail = wrap.closest('[data-hk-rail]');
          /* sequential fade: the visible panel fades out, then the chosen one
             fades in, so two sets of product titles are never on screen
             together. A token makes rapid clicks cancel the older switch. */
          var token = (wrap._hkSwitch = (wrap._hkSwitch || 0) + 1);
          var showNext = function () {
            if (token !== wrap._hkSwitch) return;
            panels.forEach(function (p) {
              p.classList.remove('is-leaving', 'is-entering');
              p.hidden = p !== next;
            });
            if (!still) { void next.offsetWidth; next.classList.add('is-entering'); }
            if (rail) rail.dispatchEvent(new Event('hk:tabchange'));
          };
          var current = panels.filter(function (p) { return !p.hidden && p !== next; })[0];
          if (current && !still) {
            panels.forEach(function (p) { p.classList.remove('is-entering'); });
            current.classList.add('is-leaving');
            setTimeout(showNext, 180);
          } else {
            showNext();
          }
          /* a scrolling tab row brings the chosen tab fully into view */
          var row = tab.parentElement;
          if (row.scrollWidth > row.clientWidth) {
            var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            /* stop the tab clear of the left-edge fade (4.8rem), matching the
               row's scroll-padding so snapping does not pull it back under */
            var pad = parseFloat(getComputedStyle(row).scrollPaddingLeft) || 0;
            var left = row.scrollLeft + tab.getBoundingClientRect().left - row.getBoundingClientRect().left - pad;
            row.scrollTo({ left: Math.max(0, left), behavior: still ? 'auto' : 'smooth' });
          }
        });
      });
    });

    /* ---- category index: hover swaps the preview image ---- */
    root.querySelectorAll('[data-hk-index]').forEach(function (section) {
      var preview = section.querySelector('.hk-index__preview');
      if (!preview) return;
      var imgs = preview.querySelectorAll('img');
      section.querySelectorAll('.hk-index__row').forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          var key = row.getAttribute('data-hk-preview');
          imgs.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-hk-key') === key);
          });
        });
      });
    });

    /* ---- social grid: hydrate from the live Instagram feed ---- */
    root.querySelectorAll('[data-hk-feed]').forEach(function (grid) {
      var src = grid.getAttribute('data-hk-feed');
      if (!src) return;
      var limit = parseInt(grid.getAttribute('data-hk-feed-limit'), 10) || 6;
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      fetch(src + sep + 'limit=' + limit, { mode: 'cors' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.posts || data.posts.length < 3) return; // keep curated tiles
          var template = grid.querySelector('.hk-social__tile');
          var frag = document.createDocumentFragment();
          data.posts.slice(0, limit).forEach(function (post) {
            var tile;
            if (template) {
              tile = template.cloneNode(true); // keeps the liquid markup + icon
              tile.removeAttribute('data-shopify-editor-block');
            } else {
              tile = document.createElement('a');
              tile.className = 'hk-social__tile';
            }
            tile.href = post.url;
            tile.target = '_blank';
            tile.rel = 'noopener';
            tile.setAttribute('aria-label', 'View this post on Instagram');
            var img = tile.querySelector('img') || tile.appendChild(document.createElement('img'));
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = post.src;
            img.alt = post.alt || 'Instagram post';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.referrerPolicy = 'no-referrer';
            frag.appendChild(tile);
          });
          grid.innerHTML = '';
          grid.appendChild(frag);
        })
        .catch(function () { /* feed down: curated tiles stay */ });
    });

    /* ---- shop the build: hotspot popovers ---- */
    var openSpot = null;
    function closeSpot() {
      if (!openSpot) return;
      openSpot.removeAttribute('data-open');
      var b = openSpot.querySelector('.hk-spot__dot');
      var pop = openSpot.querySelector('[data-hk-spot-pop]');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (pop) pop.hidden = true;
      openSpot = null;
    }
    root.querySelectorAll('[data-hk-spot]').forEach(function (spot) {
      var dot = spot.querySelector('.hk-spot__dot');
      var pop = spot.querySelector('[data-hk-spot-pop]');
      if (!dot || !pop) return;
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = openSpot === spot;
        closeSpot();
        if (wasOpen) return;
        spot.setAttribute('data-open', 'true');
        dot.setAttribute('aria-expanded', 'true');
        pop.hidden = false;
        openSpot = spot;
      });
      pop.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    if (root.querySelector('[data-hk-spot]')) {
      document.addEventListener('click', closeSpot);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSpot(); });
    }

    /* ---- shop the build: leader lines draw in once, when the photo is in view ---- */
    root.querySelectorAll('[data-hk-build]').forEach(function (fig) {
      if (!fig.querySelector('.hk-build__leaders')) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      fig.classList.add('hk-build--animate');
      var drawIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fig.classList.add('is-drawn');
          drawIo.disconnect();
        });
      }, { threshold: 0.4 });
      drawIo.observe(fig);
    });

    /* ---- fade-up reveal (landing-page data-sk2-reveal) ---- */
    var revealEls = root.querySelectorAll('[data-hk-reveal]');
    if (revealEls.length && 'IntersectionObserver' in window &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealIo.unobserve(entry.target);
        });
      }, { threshold: 0.25 });
      revealEls.forEach(function (el) {
        el.classList.add('hk-reveal--armed');
        revealIo.observe(el);
      });
    }

    /* ---- hotspot coordinate helper: ?hotspots=debug ---- */
    if (/[?&]hotspots=debug/.test(location.search)) {
      root.querySelectorAll('[data-hk-build]').forEach(function (fig) {
        fig.style.cursor = 'crosshair';
        fig.addEventListener('click', function (e) {
          var r = fig.getBoundingClientRect();
          var x = Math.round(((e.clientX - r.left) / r.width) * 100);
          var y = Math.round(((e.clientY - r.top) / r.height) * 100);
          var txt = 'x: ' + x + ', y: ' + y;
          if (navigator.clipboard) navigator.clipboard.writeText(txt).catch(function () {});
          var chip = document.createElement('div');
          chip.textContent = txt + '  (copied)';
          chip.style.cssText = 'position:absolute;z-index:9;left:' + x + '%;top:' + y + '%;transform:translate(-50%,-150%);background:#131313;color:#98dbce;font:600 12px monospace;padding:4px 8px;border-radius:4px;pointer-events:none';
          fig.appendChild(chip);
          setTimeout(function () { chip.remove(); }, 2200);
        });
      });
    }

    /* ---- sticky story: pinned image follows the beat in view ---- */
    root.querySelectorAll('[data-hk-story]').forEach(function (story) {
      var beats = [].slice.call(story.querySelectorAll('[data-hk-story-beat]'));
      var imgs = [].slice.call(story.querySelectorAll('[data-hk-story-key]'));
      if (!beats.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var key = entry.target.getAttribute('data-hk-story-beat');
          beats.forEach(function (b) { b.classList.toggle('is-active', b === entry.target); });
          imgs.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-hk-story-key') === key);
          });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      beats.forEach(function (b) { io.observe(b); });
    });

    /* ---- count-up stats ---- */
    var counters = root.querySelectorAll('[data-hk-countup]');
    if (counters.length && 'IntersectionObserver' in window) {
      var reducedCount = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          cio.unobserve(el);
          var raw = el.getAttribute('data-hk-countup') || el.textContent;
          // Only animate a value that is a plain number, optionally with a
          // prefix/suffix. Anything else (e.g. "27.5 + 29") is left alone.
          var m = /^(\D*)(\d+(?:\.\d+)?)(\D*)$/.exec(raw.trim());
          if (!m || reducedCount) { el.textContent = raw; return; }
          var pre = m[1], target = parseFloat(m[2]), post = m[3];
          var decimals = (m[2].split('.')[1] || '').length;
          var start = null, dur = 1100;
          function tick(ts) {
            if (start === null) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = pre + (target * eased).toFixed(decimals) + post;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { cio.observe(c); });
    }

    /* ---- videos: play muted while on screen, pause off screen ---- */
    var videos = root.querySelectorAll('video.hk-media-video');
    if (videos.length && 'IntersectionObserver' in window) {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting && !reduced) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { rootMargin: '80px', threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
